import { Component, computed, input, output } from '@angular/core';
import { MultiSelectDropdownComponent } from '@cumlaude/shared-components-inputs';
import { MatchCard } from '../types/match.card';
import { MatchColumn } from '../types/match.column';
import { SelectionChanged } from '../types/selection.changed';

@Component({
	selector: 'app-instelling-migratie-match-secties',
	templateUrl: './instelling-migratie-match-secties.component.html',
	styleUrls: ['./instelling-migratie-match-secties.component.scss'],
	imports: [MultiSelectDropdownComponent],
})
export class InstellingMigratieMatchSectiesComponent<T> {
	readonly titel = input.required<string>();
	readonly unmatchedCount = input<number>(0);
	readonly unmatchedLabel = input.required<string>();
	readonly autoCards = input<MatchCard<T>[]>([]);
	readonly manualCards = input<MatchCard<T>[]>([]);
	readonly placeholder = input.required<string>();
	readonly emptyAutoMatchesText = input.required<string>();
	readonly emptyManualMatchesText = input.required<string>();
	readonly emptyText = input.required<string>();

	selectionChanged = output<SelectionChanged<T>>();

	readonly columns = computed<MatchColumn<T>[]>(() => [
		{
			title: 'Met automatische match',
			cards: this.autoCards(),
			emptyText: this.emptyAutoMatchesText(),
		},
		{
			title: 'Handmatig matchen',
			cards: this.manualCards(),
			emptyText: this.emptyManualMatchesText(),
		},
	]);

	readonly hasCards = computed(() => this.autoCards().length + this.manualCards().length > 0);

	onSelectionChanged(matchIndex: number, selection: T[]): void {
		this.selectionChanged.emit({ matchIndex, selection });
	}
}
